module.exports = __webpack_public_path__ + "img/cr.6ffb1c11.svg";